/**
 * DTOs para Notificaciones del Usuario Logueado (Bandeja y No Leídas)
 */

export class UserNotificationDto {
  id: number = 0;
  title: string = '';
  message: string = '';
  is_read: boolean = false;
  notification_type: string = 'CUSTOM';
  campaign: number | null = null;
  clientuser: number | null = null;
  driver: number | null = null;
  additional_message: string | null = null;
  state: boolean = true;
  body: Record<string, any> = {};
  created_date: string = '';
  modified_date: string = '';
  deleted_date: string | null = null;

  constructor(data: Partial<UserNotificationDto> = {}) {
    Object.assign(this, data);
  }

  static fromJson(json: any): UserNotificationDto {
    const dto = new UserNotificationDto();
    if (!json) return dto;

    dto.id = json.id ?? 0;
    dto.title = json.title ?? '';
    dto.message = json.message ?? '';
    dto.is_read = json.is_read ?? false;
    dto.notification_type = json.notification_type ?? 'CUSTOM';
    dto.campaign = json.campaign ?? null;
    dto.clientuser = json.clientuser ?? null;
    dto.driver = json.driver ?? null;
    dto.additional_message = json.additional_message ?? null;
    dto.state = json.state ?? true;
    dto.body = json.body ?? {};
    dto.created_date = json.created_date ?? '';
    dto.modified_date = json.modified_date ?? '';
    dto.deleted_date = json.deleted_date ?? null;

    return dto;
  }

  toJson(): Record<string, any> {
    return { ...this };
  }
}

export class UserUnreadNotificationsResponseDto {
  count: number = 0;
  total_pages: number = 0;
  next: string | null = null;
  previous: string | null = null;
  results: UserNotificationDto[] = [];

  constructor(data: Partial<UserUnreadNotificationsResponseDto> = {}) {
    Object.assign(this, data);
  }

  static fromJson(json: any): UserUnreadNotificationsResponseDto {
    const dto = new UserUnreadNotificationsResponseDto();
    if (!json) return dto;

    dto.count = json.count ?? 0;
    dto.total_pages = json.total_pages ?? 0;
    dto.next = json.next ?? null;
    dto.previous = json.previous ?? null;
    dto.results = (json.results || []).map((item: any) => UserNotificationDto.fromJson(item));

    return dto;
  }
}
